import { InterfaceToType } from "./shared";
import { PessoaTipo } from 'features/pessoas/typings';
import { PessoaFisicaOuJuridica } from 'resources/types/pessoa';

export interface EmpresaDetalhe {
  pessoa: PessoaFisicaOuJuridica;
  endereco?: InterfaceToType<EmpresaEndereco>;
  substitutoTributario?: boolean;
  documentoResponsavel?: string;
  nomeResponsavel?: string;
  dataNascimentoResponsavel?: string;
  pessoaId?: string;
  pessoaTipo?: PessoaTipo;
}

export interface EmpresaResponse extends EmpresaDetalhe {
  id: string;
  ativo: boolean;
}

export enum TipoCadastroEmpresa {
  Fornecedor = 'fornecedor',
  Cliente = 'cliente',
}
export interface EmpresaEndereco {
  id?: string;
  estadoId: string;
  cidadeId: string;
  bairro: string;
  logradouro: string;
  complemento: string;
  cep: string;
  numero: string;
  observacao: string;
  estado?: {
    id: string;
    nome: string;
    uf: string;
  } | null;
  cidade?: {
    id: string;
    nome: string;
  } | null;
}